
import CommonInput from "../input";
import { useSelector, useDispatch } from "react-redux";
import { verifyPaystackBankAccountAction, verifyPaystackBankAccountErrorResetAction } from "../../containers/dashboard/action";
import * as React from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import CircularProgress from "@material-ui/core/CircularProgress";
import { fieldValidators } from "../../validators";
import { enqueueSnackbar } from "notistack";


function  CommonBankAccountNumber({ value, onChange, allowChange = true, ...props }) {
    const dispatch = useDispatch();
    const [current, setCurrent] = React.useState(false);
    const verifyPaystackBankAccount = useSelector((state) => state.dashboardReducer.verifyPaystackBankAccount);
    const verifyPaystackBankAccountMethod = React.useCallback((data) => dispatch(verifyPaystackBankAccountAction(data)), [dispatch]);
    const verifyPaystackBankAccountErrorResetMethod = React.useCallback(() => dispatch(verifyPaystackBankAccountErrorResetAction()), [dispatch]);
    React.useEffect(() => {
        console.log("called")
        if (verifyPaystackBankAccount?.res?.data?.account_name) {
            onChange({ ...value, account_name: verifyPaystackBankAccount?.res?.data?.account_name });
        }
    }, [verifyPaystackBankAccount]);
    React.useEffect(() => {
        console.log(value);
        if (value?.account_number?.trim()?.length === 10 && value?.bank_code) {
            verifyPaystackBankAccountMethod({ account_number: value?.account_number, bank_code: value?.bank_code });
        }
    }, [value?.account_number, value?.bank_code]);

    React.useEffect(() => {
        if (verifyPaystackBankAccount?.error) {
            enqueueSnackbar(Array.isArray(verifyPaystackBankAccount?.error) ? verifyPaystackBankAccount?.error?.join(", ") : verifyPaystackBankAccount?.error, { variant: "error", onClose: () => verifyPaystackBankAccountErrorResetMethod() });
        }
    }, [verifyPaystackBankAccount?.error]);
    return (
        <>
            <CommonInput
                value={value.account_number}
                onChange={(e) => {
                    if (e.target.value.trim().length > 10) return;
                    if (fieldValidators.validAccountNumberInput(e.target.value) || e.target.value.trim() === "") {
                        onChange({ ...value, account_number: e.target.value });
                    } else {
                        onChange({ ...value, account_number: e.target.value.replace(/\D/g, "") });
                    }
                    // onChange({ ...value, account_number: e.target.value });
                }}
                {...props}
                error={current ? (!value?.account_number || !value?.account_number?.trim()) : null}
                helperText={current ? (!value?.account_number || !value?.account_number?.trim() ? "Account Number may not be blank." : Array.isArray(verifyPaystackBankAccount?.error) ? verifyPaystackBankAccount?.error?.join(", ") : verifyPaystackBankAccount?.error) : null}
                fullWidth
                disabled={verifyPaystackBankAccount?.isLoading || !allowChange}
                InputProps={{
                    endAdornment: verifyPaystackBankAccount?.isLoading ? (
                        <InputAdornment position="end">
                            <CircularProgress size={20} />
                        </InputAdornment>
                    ) : null,
                }}
                {...{
                    error: current && !fieldValidators.validAccountNumberInput(value?.account_number),
                    helperText: current ? (fieldValidators.accountNumberHelperText(value?.account_number) || Array.isArray(verifyPaystackBankAccount?.error) ? verifyPaystackBankAccount?.error?.join(", ") : verifyPaystackBankAccount?.error) : null
                }}
                onFocus={() => setCurrent(true)}
                onBlur={() => setCurrent(false)}
            />
            <CommonInput
                placeholder="Account Name"
                value={value?.account_name || verifyPaystackBankAccount?.res?.data?.account_name || ""}
                disabled={true}
                fullWidth
            />
        </>
    );
}

export default CommonBankAccountNumber;